(function (root, factory) {
  "use strict";
  if (typeof define === 'function' && define.amd) {
    define("siteheader", ["jquery", "betteroffcanvas"], factory);
  } else {
    // Browser globals
    root.siteheader = factory(root.jQuery, root.betteroffcanvas);
  }
}(this, function ($, betteroffcanvas, ajaxCart, Handlebars) {
  "use strict";
  "feel good";

  function update_scroll() {
    let header = document.querySelector('.site-header');
    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > 0) {
      header.classList.add('site-header--sticky');
    } else {
      header.classList.remove('site-header--sticky');
    }
  }

  document.addEventListener("scroll", update_scroll);

  window.addEventListener('DOMContentLoaded', (event) => {

    /* Main navigation dropdown */
    document.querySelectorAll('.dd-mega-menu__nav-item').forEach(item => {
      item.querySelector('a').addEventListener('mouseover', function(){
        let index = this.parentNode.dataset.index;
        
        document.querySelector('.dd-mega-menu__nav-item--active').classList.remove('dd-mega-menu__nav-item--active');

        document.querySelector('.dd-mega-menu__products-grid--active').classList.remove('dd-mega-menu__products-grid--active');

        this.parentNode.classList.add('dd-mega-menu__nav-item--active');

        document.querySelector(`.dd-mega-menu__products-grid:nth-child(${index})`).classList.add('dd-mega-menu__products-grid--active');
      });
    });

    document.querySelectorAll('.js-dd-link').forEach(item => {
      item.addEventListener('mouseover', function(){
        let image = this.dataset.image;

        document.querySelector('.js-dd-img').src = image;
      });
    });

    /* Search */
    document.querySelectorAll('.js-search').forEach(item => {
      item.addEventListener('click', function(){
        document.querySelector('#search-dd').classList.add('search-dd--active');
        document.querySelector('.site-header').classList.add('site-header--open');

        setTimeout(function(){
          document.querySelector('.search-dd__input').focus();
        }, 301);
      });
    });

    document.querySelector('.search-dd__input').addEventListener('focusout', () => {
      document.querySelector('#search-dd').classList.remove('search-dd--active');
      document.querySelector('.site-header').classList.remove('site-header--open');
    });

    /* Hamburger */
    document.querySelector('.js-hamburger').addEventListener('click', function(){
      this.closest('.site-header').classList.toggle('site-header--open');
      document.querySelector('.navigation-mobile').classList.toggle('navigation-mobile--active');
    });

    document.querySelector('.js-mobile-nav-close').addEventListener('click', function(){
      this.closest('.site-header').classList.toggle('site-header--open');
      document.querySelector('.navigation-mobile').classList.toggle('navigation-mobile--active');
    });
    
  });

}));
